import { get } from '@core/Services/ApiService'
import { MeetingsAPIResponse } from './types'

export const getMeetingsFromApi = (date: string) =>
  get<MeetingsAPIResponse>({ url: '/api/meetings?date=' + date })
